import React from 'react';
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

class Footer extends React.Component {

    render() {
        const {t} = this.props;

        return (
            <div className="footer">{t('cm.text.footer')}</div>
        )
    }
}

export default withTranslation()(connect(null, null)(Footer))